import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FloorImageWrapper = styled(Box)`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .header {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 32px;
    padding-right: 32px;
    border-bottom: 1px solid #ddd;
  }

  .image-area {
    flex-grow: 1;
    background: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px;
  }

  .floor-image {
    max-width: 75%;
    max-height: 35%;
    object-fit: contain;
    border-radius: 8px;
  }
`;
